import React, { FC } from 'react';
import { MdExpandMore } from 'react-icons/md';

import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';

import styled from 'styled-components';

import aampeTheme from '../../../constants/aampeTheme';

interface AampeAccordionProps {
    title: React.ReactNode;
    defaultExpanded?: boolean;
    isExpanded?: boolean;
    setIsExpanded?: (expand: boolean) => void;
    className?: string;
}

const AampeAccordion: FC<React.PropsWithChildren<AampeAccordionProps>> = ({
    title,
    children,
    defaultExpanded = false,
    isExpanded,
    setIsExpanded,
    className,
}) => {
    return (
        <StyledAccordion
            className={className}
            expanded={isExpanded}
            onChange={() => setIsExpanded?.(!isExpanded)}
            defaultExpanded={defaultExpanded}
        >
            <AccordionSummary
                expandIcon={<MdExpandMore color={aampeTheme.colors.gray800} />}
            >
                <SummaryContent>
                    <Title>{title}</Title>
                </SummaryContent>
            </AccordionSummary>
            <AccordionDetails>{children}</AccordionDetails>
        </StyledAccordion>
    );
};

const StyledAccordion = styled(Accordion)(() => ({
    boxShadow: 'none',
    backgroundColor: 'inherit',
    '::before': {
        backgroundColor: 'inherit',
    },
}));

export default AampeAccordion;

const SummaryContent = styled.div({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
});

const Title = styled.div({
    width: '100%',
});
